export const secFilings = () => {
    const formGroupsSelect = document.getElementById('formgroups');
    const yearSelect = document.getElementById('year');
    const tbody = document.getElementById('sec-filings-data');
    const pagination = document.querySelector('.sec-filings--pagination');

    if (!formGroupsSelect || !yearSelect || !tbody) return;

    function handlePaginationClick(e) {
        e.preventDefault();
        const urlObj = new URL(e.currentTarget.href);
        let year = urlObj.searchParams.get('year') || '';
        const page = urlObj.searchParams.get('page') || '';
        const formgroups = urlObj.searchParams.get('formgroups') || '';
        const minDate = urlObj.searchParams.get('minDate') || '';
        const maxDate = urlObj.searchParams.get('maxDate') || '';

        // Store scroll position
        const scrollY = window.scrollY;

        // Show loading state
        tbody.innerHTML = '<tr><td colspan="4" style="text-align: center;">Loading...</td></tr>';

        // Make AJAX request with extracted params
        const formData = new FormData();
        formData.append('action', 'tpg_get_sec_filings');
        formData.append('nonce', localized_object.nonce);
        formData.append('form_group', formgroups);
        formData.append('page', page);
        formData.append('min_date', minDate);
        formData.append('max_date', maxDate);
        formData.append('year', year);
        //console.log('handlePaginationClick');
        //console.log(formData);

        fetch(localized_object.ajax_url, {
            method: 'POST',
            credentials: 'same-origin',
            body: formData
        })
        .then(response => response.json())
        .then(data => {
            ////console.log(data);
            if (data.success && data.data.data) {
                // Update table content
                tbody.innerHTML = data.data.data.map(filing => `
                    <tr>
                        <td data-label="Filing">${filing.formType || ''}</td>
                        <td data-label="Description">${filing.description || ''}</td>
                        <td data-label="Date Filed">${filing.dateFiled?.date ? new Date(filing.dateFiled.date).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : ''}</td>
                        <td data-label="View">
                            ${Object.entries(filing.formats || {}).map(([format, value]) => {
                                if (!value) return '';
                                const href = value.hostedUrl || value.url;
                                if (!href) return '';
                                return `<a href="${href}" class="view-filing mr-2 text-(--blue-400) hover:text-(--blue-600) no-underline uppercase" target="_blank">${format}</a>`;
                            }).join('')}
                        </td>
                    </tr>
                `).join('');

                // Update pagination
                if (data.data.links) {
                    const prevLink = pagination.querySelector('.sec-filings--pagination-prev');
                    const nextLink = pagination.querySelector('.sec-filings--pagination-next');

                    if (data.data.links.prev) {
                        prevLink.href = data.data.links.prev;
                        pagination.classList.remove('hidden');
                        prevLink.classList.remove('disabled');
                    } else {
                        prevLink.classList.add('disabled');
                    }

                    if (data.data.links.next) {
                        nextLink.href = data.data.links.next;
                        pagination.classList.remove('hidden');
                        nextLink.classList.remove('disabled');
                    } else {
                        nextLink.classList.add('disabled');
                    }
                }
            } else {
                tbody.innerHTML = '<tr><td colspan="4">No SEC filings available for the selected criteria.</td></tr>';
                pagination.classList.add('hidden');
            }
            // Restore scroll position
            window.scrollTo({ top: scrollY });
        })
        .catch(error => {
            console.error('Error:', error);
            tbody.innerHTML = '<tr><td colspan="4">Error loading SEC filings. Please try again.</td></tr>';
            pagination.classList.add('hidden');
            // Restore scroll position
            window.scrollTo({ top: scrollY });
        });
    }

    function updateFilings() {
        // Store scroll position
        const scrollY = window.scrollY;
        // Show loading state
        tbody.innerHTML = '<tr><td colspan="4" style="text-align: center;">Loading...</td></tr>';

        // Make AJAX request
        const formData = new FormData();
        formData.append('action', 'tpg_get_sec_filings');
        formData.append('nonce', localized_object.nonce);
        formData.append('form_group', formGroupsSelect.value);
        formData.append('year', yearSelect.value);
        //console.log('updateFilings');
        //console.log(formData);

        fetch(localized_object.ajax_url, {
            method: 'POST',
            credentials: 'same-origin',
            body: formData
        })
        .then(response => response.json())
        .then(data => {
            ////console.log(data);
            if (data.success && data.data.data) {
                // Update table content
                tbody.innerHTML = data.data.data.map(filing => `
                    <tr>
                        <td data-label="Filing">${filing.formType || ''}</td>
                        <td data-label="Description">${filing.description || ''}</td>
                        <td data-label="Date Filed">${filing.dateFiled?.date ? new Date(filing.dateFiled.date).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : ''}</td>
                        <td data-label="View">
                            ${Object.entries(filing.formats || {}).map(([format, value]) => {
                                if (!value) return '';
                                const href = value.hostedUrl || value.url;
                                if (!href) return '';
                                return `<a href="${href}" class="view-filing mr-2 text-(--blue-400) hover:text-(--blue-600) no-underline uppercase" target="_blank">${format}</a>`;
                            }).join('')}
                        </td>
                    </tr>
                `).join('');

                // Update pagination
                if (data.data.links) {
                    const prevLink = pagination.querySelector('.sec-filings--pagination-prev');
                    const nextLink = pagination.querySelector('.sec-filings--pagination-next');

                    if (data.data.links.prev) {
                        prevLink.href = data.data.links.prev;
                        prevLink.classList.remove('disabled');
                        pagination.classList.remove('hidden');
                    } else {
                        prevLink.classList.add('disabled');
                    }

                    if (data.data.links.next) {
                        nextLink.href = data.data.links.next;
                        nextLink.classList.remove('disabled');
                        pagination.classList.remove('hidden');
                    } else {
                        nextLink.classList.add('disabled');
                    }
                }
                
            } else {
                tbody.innerHTML = '<tr><td colspan="4">No SEC filings available for the selected criteria.</td></tr>';
                pagination.classList.add('hidden');
            }
            // Restore scroll position
            window.scrollTo({ top: scrollY });
        })
        .catch(error => {
            console.error('Error:', error);
            tbody.innerHTML = '<tr><td colspan="4">Error loading SEC filings. Please try again.</td></tr>';
            pagination.classList.add('hidden');
            // Restore scroll position
            window.scrollTo({ top: scrollY });
        });
    }

    // Add event listeners
    formGroupsSelect.addEventListener('change', updateFilings);
    yearSelect.addEventListener('change', updateFilings);

    // Add pagination event listeners
    const prevLink = pagination.querySelector('.sec-filings--pagination-prev');
    const nextLink = pagination.querySelector('.sec-filings--pagination-next');

    if (prevLink) prevLink.addEventListener('click', handlePaginationClick);
    if (nextLink) nextLink.addEventListener('click', handlePaginationClick);
};